/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespIconBubbles_viewer$ref = any;
type PdpRespTradeIconBubbles_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespIconBubblesWrapper_viewer$ref: FragmentReference;
export type PdpRespIconBubblesWrapper_viewer = {|
  +$fragmentRefs: PdpRespIconBubbles_viewer$ref & PdpRespTradeIconBubbles_viewer$ref,
  +$refType: PdpRespIconBubblesWrapper_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespIconBubblesWrapper_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespTradeIconBubbles_viewer",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '50d384ae4d7efb2d8117904c0184cfaf';
module.exports = node;
